import React from 'react';
// airport logos
// AIRPORTS
import DUB from "_assets/images/logo/DUB-logo.png";
import BFS from "_assets/images/logo/BFS-logo.png";
import EDI from "_assets/images/logo/EDI-logo.png";
import GLA from "_assets/images/logo/GLA-logo.png";
import SGS from "_assets/images/logo/SGS-logo.png";
import SYD from "_assets/images/logo/SYD-logo.png";
// profile picture component
const AirportLogos = (props) => {
    if (props.travelAgent) {
        return (
            <>
                {
                    props.iata == 'Healthcare Abroad' ?
                        <img src={healthcareAbroad} style={props.style} />
                        :
                        <img src={surgeryNow} style={props.style} />
                }
            </>
        )
    }
    else {
        return (
            <>
                {
                    props.iata == 'DUB' ?
                        <img src={DUB} style={props.style} />
                        : props.iata == 'BFS' ?
                            <img src={BFS} style={props.style} />
                            : props.iata == 'EDI' ?
                                <img src={EDI} style={props.style} />
                                : props.iata == 'GLA' ?
                                    <img src={GLA} style={props.style} />
                                    : props.iata == 'SGS' ?
                                        <img src={SGS} style={props.style} />
                                        : props.iata == 'SYD' ?
                                            <img src={SYD} style={props.style} />
                                            : <></>
                }
            </>
        )
    }
}
export default AirportLogos;